module.exports = __webpack_public_path__ + "static/media/blank-stand.ffc831f9.png";